import React from "react";
import { Link } from "react-router-dom";
import { waLink } from "@/lib/api";

export default function MobileBottomBar() {
  return (
    <div data-testid="mobile-bottom-bar" className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-brand-border flex">
      <a
        data-testid="mobile-bottom-whatsapp"
        href={waLink("Hi Hi-Tech Realty, I want to chat with the Chennai team.")}
        target="_blank"
        rel="noreferrer"
        className="flex-1 btn-whatsapp !py-4 !rounded-none !tracking-[0.14em]"
      >
        WhatsApp Us
      </a>
      <Link
        data-testid="mobile-bottom-book"
        to="/contact"
        className="flex-1 btn-cyan !py-4 !rounded-none !tracking-[0.14em]"
      >
        Book Review
      </Link>
    </div>
  );
}
